import { orderStatus } from '@/constants';
import Order from '@/entity/Order';
import { fulfillmentService, orderService, } from '@/services';
import { defineStore } from 'pinia';
import { computed, ref, } from 'vue';
/** 초기화 (reset) 안할 데이터는 이곳에 추가 */
export const prevData = {};
// pinia 출발도착관제
export const piniaLocationControl = defineStore('locationControl', () => {
    // INIT
    // STATE
    /** 주문 아이디 */
    const orderId = ref('');
    /** 총판 아이디 */
    const distId = ref('');
    /** 허브 아이디 */
    const hubId = ref('');
    /** 라이더 아이디 */
    const workerId = ref('');
    /** 주문 */
    const selectedOrder = ref(null);
    /** 배차 라이더 */
    const allocatedWorker = ref(null);
    // GETTER
    /** 주문 출발도착 위치 */
    const getterOrderLocation = computed(() => {
        const location = {
            pickup: [],
            drop: [],
        };
        if (!selectedOrder.value) {
            return location;
        }
        // 출발지
        location.pickup = [
            selectedOrder.value.pickupLatitude,
            selectedOrder.value.pickupLongitude,
        ];
        // 도착지
        location.drop = [
            selectedOrder.value.dropLatitude,
            selectedOrder.value.dropLongitude,
        ];
        return location;
    });
    /** 라이더 위치 */
    const getterWorkerLocation = computed(() => {
        if (!allocatedWorker.value) {
            return [];
        }
        return [
            allocatedWorker.value.location.latitude,
            allocatedWorker.value.location.longitude,
        ];
    });
    // ACTION
    /**
     * 주문 조회 및 라이더 조회
     */
    const getOrderAndWorker = async () => {
        const res = await orderService.getOrder({
            orderId: orderId.value,
        });
        selectedOrder.value = new Order(res.data);
        // 취소나 완료라면 라이더 조회 x
        if ([
            orderStatus.CANCELED.code,
            orderStatus.DROP_FINISHED.code,
        ].includes(selectedOrder.value.statusCode)) {
            return;
        }
        // 배차한 라이더가 있을 때만 라이더 조회
        if (selectedOrder.value.allocatedWorkerCode) {
            const fulfillment = await fulfillmentService.getFulfillmentByWorker(selectedOrder.value.allocatedDistributorId, selectedOrder.value.allocatedHubId, selectedOrder.value.allocatedWorkerCode);
            allocatedWorker.value = fulfillment;
        }
    };
    /**
     * query string 주입
     */
    const setPopupData = (data) => {
        orderId.value = data.orderId;
    };
    return {
        orderId,
        distId,
        hubId,
        workerId,
        allocatedWorker,
        selectedOrder,
        setPopupData,
        getOrderAndWorker,
        getterOrderLocation,
        getterWorkerLocation,
    };
});
